import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EmbeddedIntegrationData } from '@DTOs';
import { Observable } from 'rxjs';
import { AppService } from '../../app.service';
import { IConfigService } from '../../config/iconfigservice';
import { BaseService } from '../base.service';
import { ObservableService } from '../observable.service';

@Injectable()
export class MagnumService extends BaseService {
    publicApiBaseUrl: string;

    constructor(
        public appService: AppService,
        public httpClient: HttpClient,
        public configService: IConfigService,
        public observableService: ObservableService
    ) {
        super(appService, configService, httpClient);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    refreshToken(caseUUID: string): Observable<EmbeddedIntegrationData> {
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/magnum/caseUUID/${caseUUID}`;

        return super.getData(url);
    }
}
